try {
  const navs = document.querySelectorAll(".nav");
  for (const nav of navs) {
    const dropdowns = nav.querySelectorAll(".menu-dropdown");
    for (const dropdown of dropdowns) {
      const link = dropdown.querySelector("a");
      const div = link.nextElementSibling;
      const isVisible = () => {
        const rect = div.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      };
      const setVisible = (v) => {
        dropdown.classList.toggle("menu-dropdown-enabled", v);
      };
      const getNow = () => performance.now();
      let noClickBefore = getNow();
      const clickHandler = (evt) => {
        if (getNow() < noClickBefore) return;
        setVisible(!isVisible());
      };
      const enableHandler = (evt) => {
        if (!isVisible()) noClickBefore = getNow() + 500;
        setVisible(true);
      };
      link.addEventListener("click", clickHandler);
      link.addEventListener("focus", enableHandler);
      link.addEventListener("pointerenter", enableHandler);
      link.addEventListener("touchstart", enableHandler);
    }
  }
} catch (e) {}
